function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1 13.3a.99.99 0 10-1.4 1.4l4.593 4.593a1 1 0 001.414 0L21.3 14.7a.99.99 0 10-1.4-1.4L16 17.2l-3.9-3.9z",
  fill: "#6F8190"
});

var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4xIDEzLjNDMTEuNzEzNCAxMi45MTM0IDExLjA4NjYgMTIuOTEzNCAxMC43IDEzLjNDMTAuMzEzNCAxMy42ODY2IDEwLjMxMzQgMTQuMzEzNCAxMC43IDE0LjdMMTUuMjkyOSAxOS4yOTI5QzE1LjY4MzQgMTkuNjgzNCAxNi4zMTY2IDE5LjY4MzQgMTYuNzA3MSAxOS4yOTI5TDIxLjMgMTQuN0MyMS42ODY2IDE0LjMxMzQgMjEuNjg2NiAxMy42ODY2IDIxLjMgMTMuM0MyMC45MTM0IDEyLjkxMzQgMjAuMjg2NiAxMi45MTM0IDE5LjkgMTMuM0wxNiAxNy4yTDEyLjEgMTMuM1oiIGZpbGw9IiM2RjgxOTAiLz4KPC9zdmc+Cg==";
export { SvgIconArrowDown as ReactComponent };